import { motion, useReducedMotion } from "framer-motion";

export default function ImageReveal({ children, className = "", delay = 0, radius = "1.5rem" }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={
        reduce
          ? { opacity: 0 }
          : { opacity: 0, y: 16, clipPath: `inset(10% 5% 10% 5% round ${radius})` }
      }
      whileInView={
        reduce
          ? { opacity: 1 }
          : { opacity: 1, y: 0, clipPath: `inset(0% 0% 0% 0% round ${radius})` }
      }
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
